module.exports = __webpack_public_path__ + "static/media/bg.d1b999de.png";